import invoke from 'lodash/invoke';
import PropTypes from 'prop-types';
import React, {Component} from 'react';

import {Chevron, FormSelect, Select} from './styles';

class FormSelectBase extends Component {
  static propTypes = {
    device: PropTypes.oneOf(['desktop', 'mobile']).isRequired,
    inputId: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.string
  };

  handleChange = event => {
    invoke(this.props, 'onChange', event.target.value);
  };

  render() {
    const {children, device, inputId, value} = this.props;

    return (
      <FormSelect device={device}>
        <Select device={device} id={inputId} onChange={this.handleChange} value={value}>
          {children}
        </Select>
        <Chevron />
      </FormSelect>
    );
  }
}

export const FormSelectDesktop = props => <FormSelectBase device="desktop" {...props} />;

export const FormSelectMobile = props => <FormSelectBase device="mobile" {...props} />;
